import React from 'react';
export function Footer() {
  return <footer className="py-12 px-6 bg-charcoal text-linen/40 text-center text-sm" data-id="element-57">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-58">
        <p data-id="element-59">
          © {new Date().getFullYear()} The Quiet House Reset. All rights
          reserved.
        </p>
        <div className="flex justify-center gap-6" data-id="element-60">
          <a href="#" className="hover:text-linen transition-colors" data-id="element-61">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-linen transition-colors" data-id="element-62">
            Terms of Service
          </a>
        </div>
        <p className="text-linen/30 text-xs max-w-md mx-auto leading-relaxed mt-4" data-id="element-63">
          This product is for informational purposes only and does not replace
          professional medical or psychological advice. Individual results may
          vary.
        </p>
      </div>
    </footer>;
}